import store from '../store'

export async function authGuard(to) {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  const userRoles = store.getters['auth/userRoles']
  
  // Skip auth check for guest routes
  if (to.matched.some(record => record.meta.guest)) {
    if (isAuthenticated) {
      // If trying to access login while authenticated, redirect based on role
      if (userRoles.includes('employee') && !userRoles.includes('admin') && !userRoles.includes('hr')) {
        return { path: '/profile' }
      } else {
        return { path: '/' }
      }
    }
    return true
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    return {
      path: '/login',
      query: { redirect: to.fullPath }
    }
  }

  // Role-based redirection for home route
  if (to.path === '/' && isAuthenticated && userRoles.includes('employee') && !userRoles.includes('admin') && !userRoles.includes('hr')) {
    return { path: '/profile' }
  }

  return true
}

export function roleGuard(allowedRoles) {
  return () => {
    const hasRole = store.getters['auth/hasRole']
    
    if (hasRole(allowedRoles)) {
      return true
    }
    return { path: '/' }
  }
} 